import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { format } from 'date-fns'
import Card, { COLOR_VARIANTS } from 'components/card'
import { Carousel } from 'react-bootstrap'
import { numberToCurrency } from 'lib/money'
import { CONFIG, FREE_SHIPPING_THRESHOLD } from 'shared/constants'
import Link from 'components/link'
import { returnsPath } from 'lib/urls'
import {
  getEligibleForRegistryDiscount,
  getRegistryDiscountEndsAt,
} from 'registry/reducers'
import dateformat from 'dateformat'
import { Button } from 'baby-design'
import { RegistryDiscountDetails } from './RegistryDiscountDetails/RegistryDiscountDetails'
import css from './benefits-carousel.scss'
import classNames from 'classnames'

export const BenefitsCarousel = ({
  availableCredit,
  isEligibleForRegistryDiscount,
  registryDiscountEndsAt,
  isRegistryDiscountRevampEnabled,
  registryDiscount,
  openModal,
  isMobile,
}) => {
  const eligibleForMultiuseDiscount =
    registryDiscount?.eligibleForMultiuseDiscount

  return (
    <>
      <Card
        bgColor={COLOR_VARIANTS.BUBBLEGUM}
        className={classNames(
          css.BenefitsCarousel__container,
          'pal',
          eligibleForMultiuseDiscount
            ? css['BenefitsCarousel__container--multiuseDiscount']
            : ''
        )}
      >
        <Carousel controls={false} indicators={false} interval={3000}>
          {availableCredit > 0 && (
            <Carousel.Item className="text-inverse">
              <div className={css.BenefitsCarousel__detailHeader}>
                You have {numberToCurrency(availableCredit)} in Babylist shop
                credit
              </div>
              <div className={css.BenefitsCarousel__detail}>
                Applies at checkout
              </div>
            </Carousel.Item>
          )}
          <Carousel.Item className="text-inverse">
            <div className={css.BenefitsCarousel__detailHeader}>
              Free shipping on orders ${FREE_SHIPPING_THRESHOLD}+
            </div>
            <div className={css.BenefitsCarousel__detail}>
              and{' '}
              <Link
                className="text-inverse text-underline"
                url={returnsPath}
                newWindow
              >
                free returns
              </Link>{' '}
              on Babylist shop items
            </div>
          </Carousel.Item>
          {isEligibleForRegistryDiscount && (
            <Carousel.Item className="text-inverse">
              <RegistryDiscountDetails
                registryDiscount={registryDiscount}
                isRegistryDiscountRevampEnabled={
                  isRegistryDiscountRevampEnabled
                }
                registryDiscountEndsAt={registryDiscountEndsAt}
                openModal={openModal}
                isMobile={isMobile}
              />
            </Carousel.Item>
          )}
        </Carousel>
      </Card>
    </>
  )
}

BenefitsCarousel.propTypes = {
  availableCredit: PropTypes.number.isRequired,
  isEligibleForRegistryDiscount: PropTypes.bool.isRequired,
  registryDiscountEndsAt: PropTypes.string.isRequired,
  registryDiscount: PropTypes.object,
  isRegistryDiscountRevampEnabled: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => {
  return {
    availableCredit: state.user?.availableCredit,
    isEligibleForRegistryDiscount: getEligibleForRegistryDiscount(state),
    registryDiscountEndsAt: getRegistryDiscountEndsAt(state),
  }
}

export default connect(mapStateToProps, undefined)(BenefitsCarousel)
